import clsx from "clsx";
import { useState } from "react";
import { defaultProfileImage } from "../../../../utils/constants";
import { useExpertiseList } from "../../../../hooks/partners/useExpertiseList";
import { useExpertiseCounters } from "../../../../hooks/partners/useExpertiseCounters";
import { ExpertiseCard } from "../cards/ExpertiseCard";

interface InfoModel {
    total: number;
    declined: number;
    unasnwered: number;
    accepted: number;
    rating: string;
}


type Props = {
    partner: any;
}

export const ExpertiseExpertTab = ({ partner }: Props) => {
    const filters: {label: string, value: "requests" | "open" | "closed"}[] = [
        {label: "Requests", value: 'requests'}, 
        {label:"Open Expertise", value: 'open'}, 
        {label: "Closed Expertise", value: 'closed'}
    ];
    const [filtered, setFiltered] = useState<{label: string, value: "requests" | "open" | "closed"}>(filters[filters.length - 1]);

    const { list } = useExpertiseList(partner.id, filtered.value);
    const { counters } = useExpertiseCounters(partner.id);

    return (
        <div className="w-100 d-flex flex-column" style={{ gap: 'var(--padding-2, 20px)' }}>
            <div className="expertise-filters-wrapper">
                {filters.map((f, i) => (
                    <button onClick={() => setFiltered(f)} key={i} className={clsx({ 'active': filtered.value === f.value })}>
                        {filtered.value === f.value ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <rect x="1" y="1" width="16" height="16" rx="8" stroke="#460107" stroke-width="2"/>
                                <rect x="4" y="4" width="10" height="10" rx="5" fill="#460107"/>
                            </svg>
                        ): (
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <rect x="1" y="1" width="16" height="16" rx="8" stroke="#DFDFDF" stroke-width="2"/>
                            </svg>
                        )}
                        <span>
                            {f.label}
                        </span>
                    </button>
                ))}
            </div>

            <div className="expertise-tags-wrapper">
                <div className="tag">
                    <span className="label">Total Request</span>
                    <span className="value">{counters.totalRequests}</span>
                </div>
                <div className="tag">
                    <span className="label">Declined</span>
                    <span className="value">{counters.declined}</span>
                </div>
                <div className="tag">
                    <span className="label">Unanswered</span>
                    <span className="value">{counters.unanswered}</span>
                </div>
                <div className="tag">
                    <span className="label">Accepted</span>
                    <span className="value">{counters.accepted}</span>
                </div>
                <div className="tag">
                    <span className="label">Rating</span>
                    <span className="value">{counters.rating ?? '-'}/10</span>
                </div>
            </div>
            {list.map((l, i) => (
                <ExpertiseCard partner={partner} key={i} item={l}/>
            ))}
        </div>
    )
}